"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUuid = void 0;
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2021 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
const uuid_1 = require("uuid");
const COMMWEB_PREFIX = 'commweb-';
/**
 * Return a generated uuid that has been prefixed by a configurable prefix value.
 * @return prefix + generated uuid
 */
function getUuid(prefix = COMMWEB_PREFIX) {
    return prefix + (0, uuid_1.v4)();
}
exports.getUuid = getUuid;
//# sourceMappingURL=identifier-uuid.js.map